import React from "react";
import { Box, Paper } from "@material-ui/core";
import TextFormatter from "../Utilities/TextFormatter";

const Footer = () => (
  <Box
    component={Paper}
    sx={{
      backgroundColor: "#aa1945",
      color: "#f6e4dd",
      padding: "6px",
      borderRadius: "5px 5px 0px 0px",
    }}
  >
    <TextFormatter
      text={
        "Contact: Richard G. Clegg - (r.clegg@qmul.ac.uk)[mailto:r.clegg@qmul.ac.uk]"
      }
    />
  </Box>
);

export default Footer;
